import Briza1 from "./B5x12 (1).webp";
import Briza2 from "./B5x12 (2).webp";
import Briza3 from "./B5x12 (3).webp";
import Briza4 from "./B5x12 (4).webp";
import Briza5 from "./B5x12 (5).webp";
import Briza6 from "./B5x12 (6).webp";
import Briza7 from "./B5x12 (7).webp";
import Briza8 from "./Briza 5x12.jpg";
const Briza5images = [
  Briza8,
  Briza1,
  Briza2,
  Briza3,
  Briza4,
  Briza5,
  Briza6,
  Briza7,
];

export default Briza5images;
